import React, { ReactNode, useEffect, useState } from "react";
import styles from "./styles.module.scss";

interface CustomTabProps<T> {
  defaultActiveKey?: T;
  renderActionBtn?: () => ReactNode;
  tabItems: {
    key: T;
    label: string;
    renderItem: ReactNode;
    countIndicator?: number;
  }[];
}

export default function CustomTab<T>({
  defaultActiveKey,
  renderActionBtn,
  tabItems,
}: CustomTabProps<T>) {
  const [activeTab, setActiveTab] = useState(tabItems[0].key);

  function handleTabSelection(currentTab: T) {
    setActiveTab(currentTab);
  }

  useEffect(() => {
    if (defaultActiveKey) {
      setActiveTab(defaultActiveKey);
    }
  }, []);

  function renderTabItem() {
    return tabItems.find((tab) => tab.key === activeTab)?.renderItem;
  }

  return (
    <div className={styles.customTabContainer}>
      <header>
        <div className={styles.tabItemWrapper}>
          {tabItems.map((tab) => (
            <div
              className={styles.tabItem}
              key={tab.key as any}
              onClick={() => handleTabSelection(tab.key)}
            >
              <p
                className={`${
                  tab.key === activeTab ? styles.active : undefined
                }`}
              >
                {tab.label}
              </p>
              {tab.countIndicator ? <span>{tab.countIndicator}</span> : null}
            </div>
          ))}
        </div>
        {renderActionBtn ? renderActionBtn() : null}
      </header>
      {renderTabItem()}
    </div>
  );
}
